export default "__VITE_ASSET__DrmC$AT1__"